import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API, getWishlist } from "../lib/store";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const run = async () => {
      const hash = window.location.hash || "";
      const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
      try {
        const res = await axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true });
        try {
          const wl = await axios.get(`${API}/user/wishlist`, { withCredentials: true });
          const merged = [...new Set([...(wl.data.handles || []), ...getWishlist()])];
          localStorage.setItem("rj_wishlist", JSON.stringify(merged));
          window.dispatchEvent(new Event("rj-wishlist"));
          await axios.put(`${API}/user/wishlist`, { handles: merged }, { withCredentials: true });
        } catch (e) {
          console.warn("Wishlist merge failed:", e?.message);
        }
        setUser(res.data);
        toast.success(`Welcome, ${res.data.name?.split(" ")[0] || "back"}!`);
      } catch (e) {
        toast.error("Sign-in failed — please try again");
      } finally {
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { replace: true });
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center" data-testid="auth-callback-screen">
      <div className="text-center">
        <p className="font-heading text-2xl tracking-[0.2em] text-[#171310]">REGAL JEWELS</p>
        <p className="text-xs tracking-[0.35em] uppercase text-[#a8842c] mt-2 animate-pulse">Signing you in...</p>
      </div>
    </div>
  );
}
